@if (expand) {
  <ng-container *ngTemplateOutlet="outlet"></ng-container>
} @else {
  <div>
    <ng-container *ngTemplateOutlet="outlet"></ng-container>
  </div>
}

<ng-template #outlet>
  <ng-content></ng-content>
</ng-template>
